import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import {
  GoogleMap,
  Marker,
  withGoogleMap,
  InfoWindow,
} from 'react-google-maps';

import niaMarker from '../../../static/img/icons/location_icon.png';
import { GOOGLE_MAPS_NAV_LINK } from '../../../shared/Constants';

const styles = theme => ({
  mapContainer: {
    height: '100%',
    width: '100%',
  },
  infoWindow: {
    maxWidth: 200,
  },
  link: {
    textDecoration: 'none',
    fontSize: 15,
    color: theme.palette.text.secondary,
    '&:visited': {
      color: theme.palette.text.secondary,
    },
  },
  infoWindowHeader: {
    display: 'flex',
    justifyContent: 'center',
  },
  infoWindowText: {
    fontSize: 12,
  },
  infoWindowAction: {
    display: 'flex',
    justifyContent: 'center',
  },
  infoWindowLink: {
    textDecoration: 'none',
    color: theme.palette.text.primary,
    '&:visited': {
      color: theme.palette.text.primary,
    },
  },
  infoWindowButton: {
    marginTop: theme.spacing(),
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    fontSize: 10,
  },
  niaMarker: {
    verticalAlign: 'text-bottom',
    height: 22,
    width: 22,
  },
});

function MyInfoWindow(props) {
  const {
    id,
    open,
    onCloseMapWindow,
    niaclass,
    classes,
  } = props;
  if (id === open) {
    return (
      <InfoWindow onCloseClick={() => onCloseMapWindow()}>
        <div className={classes.infoWindow}>
          <div className={classes.infoWindowHeader}>
            <Typography color="primary" variant="body2">
              <img alt="nia marker" className={classes.niaMarker} src={niaMarker} />
              <Link to={'/location/' + niaclass.location.id} className={classes.link}>
                {niaclass.location.title}
              </Link>
            </Typography>
          </div>
          <Typography className={classes.infoWindowText}>
            {niaclass.location.address}
          </Typography>
          <a rel="noopener noreferrer" target="_blank" href={niaclass.location.website} className={classes.infoWindowText}>
            {niaclass.location.website}
          </a>
          <Typography className={classes.infoWindowText}>
            {niaclass.location.contact_phone}
          </Typography>
          <div className={classes.infoWindowAction}>
            <Button variant="outlined" size="small" color="secondary" className={classes.infoWindowButton}><a target="_blank" className={classes.infoWindowLink} rel="noopener noreferrer" href={GOOGLE_MAPS_NAV_LINK + encodeURIComponent(niaclass.location.address)}>Directions</a></Button>
            <Button variant="contained" size="small" color="secondary" className={classes.infoWindowButton} href={'/class/' + niaclass.id}>Details</Button>
          </div>
        </div>
      </InfoWindow>
    );
  }
  return null;
}

class MapComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const {
      latitude,
      longitude,
    } = this.props.coords;
    const {
      zoom,
      niaclasses,
      openWindow,
      onOpenMapWindow,
      onCloseMapWindow,
      classes,
      loading,
    } = this.props;
    return (
      <div className={classes.mapContainer}>
        <GoogleMap
          zoom={zoom}
          center={{ lat: latitude, lng: longitude }}
        />
        {!loading
          && (
            <React.Fragment>
              {niaclasses.map(niaclass => (
                <React.Fragment key={niaclass.id}>
                  {niaclass.location
                    && (
                      <Marker
                        icon={niaMarker}
                        key={niaclass.id}
                        position={{
                          lat: parseFloat(niaclass.location.geo_point.coordinates[1]),
                          lng: parseFloat(niaclass.location.geo_point.coordinates[0]),
                        }}
                        onClick={() => onOpenMapWindow(niaclass)}
                      >
                        <MyInfoWindow
                          id={niaclass.id}
                          open={openWindow}
                          onCloseMapWindow={onCloseMapWindow}
                          niaclass={niaclass}
                          classes={classes}
                        />
                      </Marker>
                    )
                  }
                </React.Fragment>
              ))}
            </React.Fragment>
          )
        }
      </div>
    );
  }
}

MapComponent.propTypes = {
  coords: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
  niaclasses: PropTypes.array.isRequired,
  onOpenMapWindow: PropTypes.func.isRequired,
  onCloseMapWindow: PropTypes.func.isRequired,
  openWindow: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

MyInfoWindow.propTypes = {
  id: PropTypes.number.isRequired,
  open: PropTypes.number.isRequired,
  onCloseMapWindow: PropTypes.func.isRequired,
  niaclass: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withGoogleMap(MapComponent));
